$(() => {
  $(document).ready(function() {
    $("#claim-canva-coupon").on("click", function(_event) {
      window.track("CanvaPromotion", "open_coupon_link", "1bn_partner_coupons")
    })
  })
})
